'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ISOStringFieldPackager = require('./ISOStringFieldPackager');

var _ISOStringFieldPackager2 = _interopRequireDefault(_ISOStringFieldPackager);

var _NullPadder = require('../NullPadder');

var _NullPadder2 = _interopRequireDefault(_NullPadder);

var _AsciiInterpreter = require('../AsciiInterpreter');

var _AsciiInterpreter2 = _interopRequireDefault(_AsciiInterpreter);

var _AsciiPrefixer = require('../AsciiPrefixer');

var _AsciiPrefixer2 = _interopRequireDefault(_AsciiPrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Bruno bruno.camargos@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2016/01/18
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var IFA_LLLCHAR = function (_ISOStringFieldPackag) {
    _inherits(IFA_LLLCHAR, _ISOStringFieldPackag);

    function IFA_LLLCHAR(len, description) {
        _classCallCheck(this, IFA_LLLCHAR);

        var _this = _possibleConstructorReturn(this, (IFA_LLLCHAR.__proto__ || Object.getPrototypeOf(IFA_LLLCHAR)).call(this, len, description, _NullPadder2.default, _AsciiInterpreter2.default, _AsciiPrefixer2.default.LLL));

        _this.checkLength(len, 999);
        return _this;
    }

    _createClass(IFA_LLLCHAR, [{
        key: 'setLength',
        value: function setLength(len) {
            this.checkLength(len, 999);
            _get(IFA_LLLCHAR.prototype.__proto__ || Object.getPrototypeOf(IFA_LLLCHAR.prototype), 'setLength', this).call(this, len);
        }
    }]);

    return IFA_LLLCHAR;
}(_ISOStringFieldPackager2.default);

exports.default = IFA_LLLCHAR;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/packer/IFA_LLLCHAR.js
// module id = 74
// module chunks = 0